import { PageTitle, PageLabeledButton } from 'components';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import { redirectToHome } from 'store/user/actions';
import keycloak from 'Keycloak.js';

const AlreadyLoggedPage = () => {
  const dispatch = useDispatch();
  const initiated =  useSelector(state => state.form.initiated);
  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    keycloak.tracker.invalidateUserForAuthPages(false, (data) => { 
      keycloak.tracker.installMonitorIdmSession(data, true);
      dispatch({ type: formTypes.SET_FORM_INITIATED });
     }); 
  }, []);
  return (
    initiated &&
    <div className="alreadylogged-page">
      <PageTitle message="Είστε ήδη σε σύνδεση." pageName="alreadylogged" />
      <PageLabeledButton
        labelMessage="Μεταβείτε στην αρχική σελίδα"
        pageName="homeret"
        buttonTitle="Αρχική Σελίδα"
        buttonAction={redirectToHome}
      />
    </div>
  );
};

export default AlreadyLoggedPage;
